export default __webpack_public_path__ + "static/media/logo-light.6c2a80c2.png";